/**
 * Well known properties
 * - configuration
 * - attributes
 * - values
 *
 * @see https://git.n4group.eu/plansoft/plan-software/3pq/configuration-renderer/configuration-renderer-monorepo/-/issues/90
 */
export var StandardConfigurationProperty;
(function (StandardConfigurationProperty) {
    /**
     * Info text on attributes
     *
     * Is used for
     * - help dialog for attributes and values
     *
     * Previously known as
     * - `ADATA_TEXT_MOUSEOVER
     */
    StandardConfigurationProperty["InfoText"] = "InfoText";
    /**
     * File link explaining the attribute or value
     *
     * Previously known as
     * - `ADATA_HELP_FILE`
     *
     * @deprecated This will be removed in favor of attachments
     */
    StandardConfigurationProperty["InfoFile"] = "InfoFile";
    /**
     * Info image on attributes and values
     *
     * Image displayed in a dialog.
     *
     * Previously known as
     * - `ADATA_IMAGE_MOUSEOVER`
     *
     * @deprecated This will be removed in favor of attachments
     */
    StandardConfigurationProperty["InfoImage"] = "InfoImage";
})(StandardConfigurationProperty || (StandardConfigurationProperty = {}));
//# sourceMappingURL=StandardConfigurationProperty.js.map